exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1EJ48QAfo1{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"list": "_1EJ48QAfo1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/GoalsPage/GoalsPage.scss
// module id = 696
// module chunks = 5